import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import { useNotificationMessage } from 'src/common/notification/message.hook';
import { getReferralLink } from 'src/dashboard/helpers/invite';

type Props = {
  onReferralLinkCopy: () => void;
};

const ManagementDropdownReferralsTab = ({ onReferralLinkCopy }: Props) => {
  const { setSuccessNotification } = useNotificationMessage();
  const url = getReferralLink();

  const onCopy = () => {
    setSuccessNotification('URL copied to clipboard');
    onReferralLinkCopy();
  };

  return (
    <div className='flex flex-col justify-start space-y-2'>
      <div className='text-bedrock-p bg-bedrock-light-gray px-4 py-2 w-fit rounded-lg'>{url}</div>

      <CopyToClipboard text={`${process.env.HTTP_PROTOCOL}://${url}`} onCopy={onCopy}>
        <div className='btn-bedrock-secondary text-bedrock-p-strong cursor-pointer w-fit'>
          Copy referral link to clipboard
        </div>
      </CopyToClipboard>
    </div>
  );
};

export default ManagementDropdownReferralsTab;
